// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./primevendors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE */

.e2e_training_page{
  background:#ffffff;
  padding:22px;
  border-radius:22px;
  border:1px solid #edf2f7;
  box-shadow:
    0 8px 28px rgba(15,23,42,0.05);
}

/* TOP */

.e2e_training_top{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-bottom:24px;
  gap:18px;
  flex-wrap:wrap;
}

/* TITLE */

.e2e_training_left h2{
  font-size:24px;
  font-weight:800;
  color:#0f172a;
  margin:0;
}

/* LINE */

.e2e_training_heading_line{
  width:90px;
  height:4px;
  margin-top:10px;
  border-radius:20px;
  background:
    linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
    );
}

/* BUTTON */

.e2e_training_right button{
  border:none;
  background:
    linear-gradient(
      135deg,
      #1677ff,
      #2563eb
    );
  color:white;
  height:42px;
  padding:0 22px;
  border-radius:12px;
  font-size:13px;
  font-weight:700;
  cursor:pointer;
}

/* FILTERS */

.e2e_training_filters{
  background:#f8fafc;
  border:1px solid #edf2f7;
  border-radius:18px;
  padding:18px 20px;
  display:flex;
  justify-content:space-between;
  align-items:center;
  gap:20px;
  margin-bottom:20px;
}

/* FILTER LEFT */

.e2e_training_filter_left{
  display:flex;
  align-items:center;
  gap:16px;
}

/* GROUP */

.e2e_training_filter_group{
  display:flex;
  align-items:center;
  gap:10px;
}

/* SELECT */

.e2e_training_filter_group select{
  height:40px;
  min-width:180px;
  padding:0 14px;
  border:1px solid #dbe2ea;
  border-radius:12px;
}

/* REPORT */

.e2e_training_report_btn{
  height:40px;
  border:none;
  background:
    linear-gradient(
      135deg,
      #06b6d4,
      #0891b2
    );
  color:white;
  padding:0 18px;
  border-radius:12px;
  font-size:13px;
  font-weight:700;
  cursor:pointer;
}

/* SEARCH */

.e2e_training_filter_right input{
  width:260px;
  height:40px;
  padding:0 16px;
  border:1px solid #dbe2ea;
  border-radius:12px;
}

/* SHOW */

.e2e_training_show_section{
  margin-bottom:18px;
}

/* TABLE */

.e2e_training_table_wrapper{
  overflow-x:auto;
}

.e2e_training_table{
  width:100%;
  border-collapse:separate;
  border-spacing:0 12px;
  table-layout:fixed;
}

/* TH */

.e2e_training_th{
  padding:16px 14px;
  font-size:13px;
  font-weight:800;
  text-transform:uppercase;
  color:#475569;
  border-top:1px solid #e2e8f0;
  border-bottom:1px solid #e2e8f0;
  text-align:center;
}

/* ROW */

.e2e_training_table_row{
  background:white;
  box-shadow:
    0 3px 12px rgba(15,23,42,0.04);
}

/* TD */

.e2e_training_td{
  padding:18px 16px;
  vertical-align:middle;
  font-size:14px;
  font-weight:600;
  color:#0f172a;
  border-top:1px solid #f1f5f9;
  border-bottom:1px solid #f1f5f9;
  text-align:center;
}

/* WIDTHS */

.e2e_training_th_id,
.e2e_training_td_id{
  width:50px;
}

.e2e_training_th_candidate,
.e2e_training_td_candidate{
  width:38%;
  text-align:left;
}

.e2e_training_th_email,
.e2e_training_td_email{
  width:40%;
  padding-right: 10%;
}

.e2e_training_th_phone,
.e2e_training_td_phone{
  width:40%;
  padding-right: 10%;
}

.e2e_training_th_action,
.e2e_training_td_action{
  width:220px;
}

/* DETAILS */

.e2e_training_details{
  display:flex;
  flex-direction:column;
  gap:8px;
}

.e2e_training_text{
  margin:0;
  line-height:1.5;
  color:#475569;
  font-size:13px;
}

.e2e_training_text strong{
  color:#0f172a;
  margin-left:5px;
}

/* ACTIONS */

.e2e_training_actions{
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px;
}

/* BUTTONS */

.viewBtn,
.editBtn,
.deleteBtn{
  border:none;
  min-width:64px;
  height:32px;
  border-radius:10px;
  font-size:11px;
  font-weight:700;
  cursor:pointer;
}

.viewBtn{
  background:#dbeafe;
  color:#2563eb;
}

.editBtn{
  background:#fef3c7;
  color:#d97706;
}

.deleteBtn{
  background:#fee2e2;
  color:#dc2626;
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/training.css"],"names":[],"mappings":"AAEA,SAAS;;AAET;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB;kCACgC;AAClC;;AAEA,QAAQ;;AAER;EACE,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA,UAAU;;AAEV;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA,SAAS;;AAET;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB;;;;;KAKG;AACL;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX;;;;;KAKG;EACH,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,YAAY;;AAEZ;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA,gBAAgB;;AAEhB;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA,UAAU;;AAEV;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,WAAW;EACX;;;;;KAKG;EACH,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,SAAS;;AAET;EACE,kBAAkB;AACpB;;AAEA,UAAU;;AAEV;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,OAAO;;AAEP;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,QAAQ;;AAER;EACE,gBAAgB;EAChB;kCACgC;AAClC;;AAEA,OAAO;;AAEP;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,aAAa;EACb,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,WAAW;;AAEX;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA,YAAY;;AAEZ;EACE,YAAY;EACZ,qBAAqB;EACrB,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,YAAY;;AAEZ;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;AACT;;AAEA,YAAY;;AAEZ;;;EAGE,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["@import \"./primevendors.css\";\r\n\r\n/* PAGE */\r\n\r\n.e2e_training_page{\r\n  background:#ffffff;\r\n  padding:22px;\r\n  border-radius:22px;\r\n  border:1px solid #edf2f7;\r\n  box-shadow:\r\n    0 8px 28px rgba(15,23,42,0.05);\r\n}\r\n\r\n/* TOP */\r\n\r\n.e2e_training_top{\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  margin-bottom:24px;\r\n  gap:18px;\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* TITLE */\r\n\r\n.e2e_training_left h2{\r\n  font-size:24px;\r\n  font-weight:800;\r\n  color:#0f172a;\r\n  margin:0;\r\n}\r\n\r\n/* LINE */\r\n\r\n.e2e_training_heading_line{\r\n  width:90px;\r\n  height:4px;\r\n  margin-top:10px;\r\n  border-radius:20px;\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #2563eb,\r\n      #7c3aed\r\n    );\r\n}\r\n\r\n/* BUTTON */\r\n\r\n.e2e_training_right button{\r\n  border:none;\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #1677ff,\r\n      #2563eb\r\n    );\r\n  color:white;\r\n  height:42px;\r\n  padding:0 22px;\r\n  border-radius:12px;\r\n  font-size:13px;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n}\r\n\r\n/* FILTERS */\r\n\r\n.e2e_training_filters{\r\n  background:#f8fafc;\r\n  border:1px solid #edf2f7;\r\n  border-radius:18px;\r\n  padding:18px 20px;\r\n  display:flex;\r\n  justify-content:space-between;\r\n  align-items:center;\r\n  gap:20px;\r\n  margin-bottom:20px;\r\n}\r\n\r\n/* FILTER LEFT */\r\n\r\n.e2e_training_filter_left{\r\n  display:flex;\r\n  align-items:center;\r\n  gap:16px;\r\n}\r\n\r\n/* GROUP */\r\n\r\n.e2e_training_filter_group{\r\n  display:flex;\r\n  align-items:center;\r\n  gap:10px;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.e2e_training_filter_group select{\r\n  height:40px;\r\n  min-width:180px;\r\n  padding:0 14px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:12px;\r\n}\r\n\r\n/* REPORT */\r\n\r\n.e2e_training_report_btn{\r\n  height:40px;\r\n  border:none;\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #06b6d4,\r\n      #0891b2\r\n    );\r\n  color:white;\r\n  padding:0 18px;\r\n  border-radius:12px;\r\n  font-size:13px;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n}\r\n\r\n/* SEARCH */\r\n\r\n.e2e_training_filter_right input{\r\n  width:260px;\r\n  height:40px;\r\n  padding:0 16px;\r\n  border:1px solid #dbe2ea;\r\n  border-radius:12px;\r\n}\r\n\r\n/* SHOW */\r\n\r\n.e2e_training_show_section{\r\n  margin-bottom:18px;\r\n}\r\n\r\n/* TABLE */\r\n\r\n.e2e_training_table_wrapper{\r\n  overflow-x:auto;\r\n}\r\n\r\n.e2e_training_table{\r\n  width:100%;\r\n  border-collapse:separate;\r\n  border-spacing:0 12px;\r\n  table-layout:fixed;\r\n}\r\n\r\n/* TH */\r\n\r\n.e2e_training_th{\r\n  padding:16px 14px;\r\n  font-size:13px;\r\n  font-weight:800;\r\n  text-transform:uppercase;\r\n  color:#475569;\r\n  border-top:1px solid #e2e8f0;\r\n  border-bottom:1px solid #e2e8f0;\r\n  text-align:center;\r\n}\r\n\r\n/* ROW */\r\n\r\n.e2e_training_table_row{\r\n  background:white;\r\n  box-shadow:\r\n    0 3px 12px rgba(15,23,42,0.04);\r\n}\r\n\r\n/* TD */\r\n\r\n.e2e_training_td{\r\n  padding:18px 16px;\r\n  vertical-align:middle;\r\n  font-size:14px;\r\n  font-weight:600;\r\n  color:#0f172a;\r\n  border-top:1px solid #f1f5f9;\r\n  border-bottom:1px solid #f1f5f9;\r\n  text-align:center;\r\n}\r\n\r\n/* WIDTHS */\r\n\r\n.e2e_training_th_id,\r\n.e2e_training_td_id{\r\n  width:50px;\r\n}\r\n\r\n.e2e_training_th_candidate,\r\n.e2e_training_td_candidate{\r\n  width:38%;\r\n  text-align:left;\r\n}\r\n\r\n.e2e_training_th_email,\r\n.e2e_training_td_email{\r\n  width:40%;\r\n  padding-right: 10%;\r\n}\r\n\r\n.e2e_training_th_phone,\r\n.e2e_training_td_phone{\r\n  width:40%;\r\n  padding-right: 10%;\r\n}\r\n\r\n.e2e_training_th_action,\r\n.e2e_training_td_action{\r\n  width:220px;\r\n}\r\n\r\n/* DETAILS */\r\n\r\n.e2e_training_details{\r\n  display:flex;\r\n  flex-direction:column;\r\n  gap:8px;\r\n}\r\n\r\n.e2e_training_text{\r\n  margin:0;\r\n  line-height:1.5;\r\n  color:#475569;\r\n  font-size:13px;\r\n}\r\n\r\n.e2e_training_text strong{\r\n  color:#0f172a;\r\n  margin-left:5px;\r\n}\r\n\r\n/* ACTIONS */\r\n\r\n.e2e_training_actions{\r\n  display:flex;\r\n  align-items:center;\r\n  justify-content:center;\r\n  gap:8px;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.viewBtn,\r\n.editBtn,\r\n.deleteBtn{\r\n  border:none;\r\n  min-width:64px;\r\n  height:32px;\r\n  border-radius:10px;\r\n  font-size:11px;\r\n  font-weight:700;\r\n  cursor:pointer;\r\n}\r\n\r\n.viewBtn{\r\n  background:#dbeafe;\r\n  color:#2563eb;\r\n}\r\n\r\n.editBtn{\r\n  background:#fef3c7;\r\n  color:#d97706;\r\n}\r\n\r\n.deleteBtn{\r\n  background:#fee2e2;\r\n  color:#dc2626;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
